<fieldset
	[formGroup]="formGroup"
	cdxFieldset
	[divider]="false"
	[legend]="title"
	[hideLegend]="false"
	[i18n]="'@@packingslippreferences-title'"
>
	<p *ngIf="description">{{ description }}</p>
	<div>
		<form-selection-tile
			data-cy="selectionPaperPackingSlip"
			inputId="digital-packing-slip"
			[formControlName]="controlName"
			inputValue="digital"
			i18n="@@selection-digitalPackingSlip"
			[successIcon]="true"
			label="Digital packing slip"
			description="Delivered via email"
			class="selectionTile-checkbox--left"
		>
			<cdx-sustainable-badge details size="large"></cdx-sustainable-badge>
		</form-selection-tile>
	</div>
	<div>
		<form-selection-tile
			data-cy="selectionPaperPackingSlip"
			inputId="paper-packing-slip"
			[formControlName]="controlName"
			inputValue="paper"
			i18n="@@selection-paperPackingSlip"
			[successIcon]="true"
			label="Paper packing slip"
			description="Placed in your order, a copy is also sent via email"
			class="selectionTile-checkbox--left"
		>
		</form-selection-tile>
	</div>
</fieldset>
